import React, { useCallback, useMemo, useReducer } from 'react';

import searchConstants from './search.constants';
import SearchContext from './search.context';
import searchReducer from './search.reducer';
import searchInitialState from './search.state';

import useRequest from '../../common/services/request';

/**
 * @type {React.FC}
 */

const SearchProvider = function({
  children,
  value = searchInitialState,
}) {
  const [state, dispatch] = useReducer(searchReducer, value);
  const { post }          = useRequest();

  const search = useCallback((search) => {
    const url = '/get-searching-data';
    dispatch({ type: searchConstants.SEARCH_REQUEST });

    post(url, { search })
      .then((response) => {
        dispatch({ type: searchConstants.SEARCH_SUCCESS, ...response });
      })
      .catch((error) => {
        dispatch({ type: searchConstants.SEARCH_FAILURE, ...error });
      });

  }, [dispatch]);

  const searchClose = useCallback(() => {
    dispatch({ type: searchConstants.SEARCH_CLOSE });
  }, [dispatch]);

  const searchOpen = useCallback(() => {
    dispatch({ type: searchConstants.SEARCH_OPEN });
  }, [dispatch]);

  const searchReset = useCallback(() => {
    dispatch({ type: searchConstants.SEARCH_RESET });
  }, [dispatch]);

  const context = useMemo(() => ({
    ...state,
    search,
    searchClose,
    searchOpen,
    searchReset,
  }), [search, searchClose, searchOpen, searchReset, state]);

  return (
    <SearchContext.Provider value={context}>
      {children}
    </SearchContext.Provider>
  );
};

export default SearchProvider;